import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Paper, Stack, styled, Typography } from '@mui/material';
import { actions as walletActions } from '../services/wallet';
import MintDialog from "./MintDialog";
import MintPendingDialog from "./MintPendingDialog";
import Countdown, { CountdownRenderProps } from 'react-countdown';
import { RootState } from "../store";
import { padNumber } from "../utils/padNumber";

const Root = styled(Paper)({
  textAlign: 'center',
  padding: 40,
  borderRadius: 20,
});

const PresaleMint: React.FC = () => {
  const stats = useSelector((state: RootState) => state.stats);
  const [ mintModalOpen, setMintModalOpen ] = useState(false);
  const [ mintPendingOpen, setMintPendingOpen ] = useState(false);

  const dispatch = useDispatch();

  const onMintClick = () => {
    dispatch(
      walletActions.connectWallet({
        onConnected: () => {
          setMintModalOpen(true);
        }
      })
    );
  }

  const closeMintModal = () => {
    setMintModalOpen(false);
  }

  const closeMintPending = () => {
    setMintPendingOpen(false);
  }

  const onMintStarted = () => {
    closeMintModal();
    setMintPendingOpen(true);
  }

  const renderer = (args: CountdownRenderProps) => {
    const hours = padNumber(args.hours, 2);
    const minutes = padNumber(args.minutes, 2);
    const seconds = padNumber(args.seconds, 2);
    return (
      <Stack direction="row" spacing={3}>
        {
          args.days > 0 ? <Typography variant="h5" sx={{ color: '#8ab4f8' }}>{args.days} Days</Typography> : null
        }
        <Typography variant="h5" sx={{ color: '#fcd56c' }}>{hours} Hours</Typography>
        <Typography variant="h5" sx={{ color: '#f28b82' }}>{minutes} Minutes</Typography>
        {
          args.days === 0 ? <Typography variant="h5" sx={{ color: '#81c995' }}>{seconds} Seconds</Typography> : null
        }
      </Stack>
    )
  };

  return (
    <Root variant="outlined">
      <Typography variant="h6">PRE-SALE</Typography>
      <Typography sx={{ mb: 2 }}>only whitelisted wallets can mint now.</Typography>
      <Button variant="contained" color="secondary" size="large" onClick={onMintClick}>
        Mint Now ({stats.currentPrice} eth)
      </Button>

      <MintDialog open={mintModalOpen} onClose={closeMintModal} onMintStarted={onMintStarted} />
      <MintPendingDialog open={mintPendingOpen} onClose={closeMintPending} />

      <Box sx={{ mt: 5, textAlign: 'center' }}>
        <Typography>pre-sale ends in</Typography>
        <Countdown
          date={new Date(process.env.GATSBY_PRESALE_END_DATE as string)}
          renderer={renderer}
        />
      </Box>
    </Root>
  );
};

export default PresaleMint;